import React, { Component } from "react";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
class CockatooApp extends Component {
  state = {};
  render() {
    return (
      <div align="center">
        <h1>Cockatoo Application</h1>
        <div>
          <Image
            src="\images\cockatooApplicationPage\icon_AndroidStudio.png"
            style={{ width: "10%" }}
          ></Image>
          <Image
            src="\images\cockatooApplicationPage\icon_Firebase.png"
            style={{ width: "10%" }}
          ></Image>
          <Image
            src="\images\cockatooApplicationPage\icon_React.png"
            style={{ width: "10%" }}
          ></Image>
        </div>
        <div style={{ margin: "20px" }}>
          <Image
            src="\images\cockatooApplicationPage\untitled.gif"
            width="200px"
          ></Image>
        </div>
        <div className="p-3 mb-2 bg-info text-white">
          <div style={{ margin: "20px" }}>
            <Image
              src="\images\cockatooApplicationPage\logoSection.png"
              style={{ width: "100%", maxWidth: "700px", marginTop: "30px" }}
              align="center"
            ></Image>
            <div style={{ margin: "30px" }}>
              <h4>
                Upload logo name / logo image with the android application.
              </h4>
              <h4>
                The data is stored in FIREBASE Storage and Realtime Database.
              </h4>
              <h4>website takes the data from FIREBASE.</h4>
            </div>
          </div>
        </div>
        <div>
          <Image
            src="\images\cockatooApplicationPage\contactUsSection.png"
            style={{ width: "100%", maxWidth: "700px", marginTop: "30px" }}
            align="center"
          ></Image>
          <div style={{ margin: "30px" }}>
            <h4>Writes the message on the web</h4>
            <h4>The message data is stored in FIREBASE</h4>
            <h4>The message will appear in the android Application</h4>
          </div>
        </div>

        <div className="p-3 mb-2 bg-info text-white">
          <Image
            src="\images\cockatooApplicationPage\employeeSection.png"
            style={{ width: "100%", maxWidth: "1000px", marginTop: "30px" }}
            align="center"
          ></Image>
          <div style={{ margin: "30px" }}>
            <h4>Add/Edit/Delete contacts in android application</h4>
            <h4>The contacts data stored in FIREBASE</h4>
          </div>
        </div>
        <div>
          <Image
            src="\images\cockatooApplicationPage\carouselSection.png"
            style={{ width: "100%", maxWidth: "700px", marginTop: "30px" }}
            align="center"
          ></Image>
          <div style={{ margin: "30px" }}>
            <h4>Add/Edit/Delete carousel in android application</h4>
            <h4>The contacts data stored in FIREBASE</h4>
          </div>
        </div>
      </div>
    );
  }
}

export default CockatooApp;
